<div
  class="gw-mt-6 gw-border-base gw-bg-background-elevation-2 md:gw-rounded-2xl"
>
  <div
    class="gw-border-content-header gw-border-0 gw-border-b gw-border-b-[1px] gw-border-b-border-normal gw-border-solid gw-bg-background-neutral-1 gw-h-[56px] gw-flex gw-justify-between gw-items-center gw-px-4 md:gw-px-6"
  >
    <p class="gw-text-[16px] gw-text-text-primary gw-font-bold">
      {{ titleKey || defaultTitleKey | translate }}
    </p>
  </div>
  <div class="gw-p-x-large gw-flex gw-flex-col gw-gap-medium">
    <div class="gw-flex gw-items-center gw-gap-small">
      <gatewee-icon
        icon="@tui.info"
        iconStyle="outline"
        size="16px"
      ></gatewee-icon>
      <p class="gw-text-[12px] gw-text-text-secondary gw-m-0">
        {{ hintKey || defaultHintKey | translate }}
      </p>
    </div>
    <div
      class="gw-flex gw-flex-wrap gw-gap-x-large gw-gap-y-medium gw-items-center"
      [formGroup]="paymentMethodGroup"
    >
      <gatewee-checkbox
        *ngFor="let m of methods"
        [formControlName]="m"
        [label]="(m | paymentMethod) || m"
      ></gatewee-checkbox>
    </div>
    <div class="gw-flex gw-flex-wrap gw-gap-medium gw-items-center">
      <button
        type="button"
        class="gw-text-sm gw-text-primary gw-underline gw-bg-transparent gw-border-0 gw-cursor-pointer gw-p-0"
        (click)="selectAll.emit()"
      >
        {{ 'features.checkouts.wizard.paymentMethods.selectAll' | translate }}
      </button>
      <button
        type="button"
        class="gw-text-sm gw-text-primary gw-underline gw-bg-transparent gw-border-0 gw-cursor-pointer gw-p-0"
        (click)="clearSelection.emit()"
      >
        {{
          'features.checkouts.wizard.paymentMethods.clearSelection' | translate
        }}
      </button>
    </div>
    <ng-content></ng-content>
  </div>
</div>
